const nestedConvertHtmlToString = (html: ChildNode, index: number) => {
  let result = '';
  if (html instanceof Text) {
    return result + (html.textContent || '');
  } else if (html instanceof HTMLElement) {
    if (html.tagName === 'P' && index !== 0) {
      result = '\n' + result;
    }
    if (html.tagName === 'DIV' && index !== 0) {
      result = '\n' + result;
    }
    if (html.childNodes.length === 0) {
      return result + html.innerText;
    }

    for (let i = 0; i < html.childNodes.length; i++) {
      const child = html.childNodes[i];
      if (child == null) continue;

      result += nestedConvertHtmlToString(child, i);
    }
  }

  return result;
};

export const downloadAsCsv = (filename: string, csv: string) => {
  const csvData = new Blob([csv], { type: 'text/csv' });
  const csvUrl = URL.createObjectURL(csvData);
  const hiddenElement = document.createElement('a');
  hiddenElement.href = csvUrl;
  hiddenElement.target = '_blank';
  hiddenElement.download = `${filename}.csv`;
  hiddenElement.click();
};

export const convertHtmlToString = (html = '') => {
  if (html === '<p><br></p>') return '';
  if (html === '<div><br></div>') return '';

  const div = document.createElement('div');
  div.innerHTML = html;

  return nestedConvertHtmlToString(div, 0);
};

export const scrollToDivider = (type: 'scheduled_divider' | 'today_divider') => {
  let element: HTMLElement | null = null;
  let intervalId: NodeJS.Timeout | null = null;
  let count = 0;

  element = document.getElementById(type);

  if (element) {
    element.scrollIntoView({ behavior: 'instant', block: 'start' });
  } else {
    intervalId = setInterval(() => {
      if (count >= 10 && intervalId) {
        clearInterval(intervalId);
      }
      element = document.getElementById(type);
      if (element) {
        element.scrollIntoView({ behavior: 'instant', block: 'start' });
        if (intervalId) clearInterval(intervalId);
      } else {
        count += 1;
      }
    }, 100);
  }
};
